import { render, staticRenderFns } from "./questionbankList.vue?vue&type=template&id=6e0677a4"
import script from "./questionbankList.vue?vue&type=script&lang=js"
export * from "./questionbankList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports